module.exports = __webpack_public_path__ + "static/img_1869-e0a5f75bb98188fcce16226935d5513f.webp";